module.exports = __webpack_public_path__ + "img/icon_tone_color.f75f2e03.svg";